"use client";

import { Plus } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useSidebar } from "@/components/ui/sidebar";
import type { AdminQuickAction } from "@/lib/adminNavigation";
import { useRouter } from "@/lib/router-compat";

export function NavigationQuickCreate({
  actions,
}: {
  actions: readonly AdminQuickAction[];
}) {
  const router = useRouter();
  const { isMobile, setOpenMobile } = useSidebar();

  if (actions.length === 0) return null;

  const handleSelect = (url: string) => {
    router.push(url);
    if (isMobile) setOpenMobile(false);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="新規作成メニューを開く"
          title="新規作成"
          className="bg-primary text-primary-foreground hover:bg-primary/90 focus-visible:ring-ring flex size-11 shrink-0 cursor-pointer items-center justify-center rounded-lg shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 group-data-[collapsible=icon]:mx-auto group-data-[collapsible=icon]:size-9"
        >
          <Plus className="size-4 shrink-0" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="right"
        align="start"
        sideOffset={8}
        className="w-72"
      >
        <DropdownMenuLabel>
          <span className="block text-sm font-semibold">新規作成</span>
          <span className="text-muted-foreground  block text-xs font-normal">
            行いたい操作を直接選べます
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <DropdownMenuItem
              key={action.id}
              onSelect={() => handleSelect(action.url)}
              className="min-h-12 cursor-pointer items-start py-2"
            >
              <Icon className="mt-0.5 size-4" aria-hidden="true" />
              <span className="min-w-0">
                <span className="block font-medium">{action.title}</span>
                <span className="text-muted-foreground block text-xs leading-5">
                  {action.description}
                </span>
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
